import {DeclarationStatus, TaskMessageStatus} from "@portbase/bezoekschip-service-typescriptmodels";

export class NewPortvisitUtils {

  static declarationStatusToTaskMessageStatus = (status: DeclarationStatus): TaskMessageStatus => {
    switch (status) {
      case DeclarationStatus.DECLARED:
        return TaskMessageStatus.PENDING;
      case DeclarationStatus.ACCEPTED:
        return TaskMessageStatus.ACCEPTED;
      case DeclarationStatus.REJECTED:
        return TaskMessageStatus.REJECTED;
      default:
        return TaskMessageStatus.UNKNOWN;
    }
  }

  static taskMessageStatusToDeclarationStatus = (status: TaskMessageStatus): DeclarationStatus => {
    switch (status) {
      case TaskMessageStatus.PENDING:
        return DeclarationStatus.DECLARED;
      case TaskMessageStatus.ACCEPTED:
        return DeclarationStatus.ACCEPTED;
      case TaskMessageStatus.REJECTED:
        return DeclarationStatus.REJECTED;
      default:
          return null;
    }
  }

}
